import { render, staticRenderFns } from "./ShoppingBasketFull.vue?vue&type=template&id=07945b3d&scoped=true&"
import script from "./ShoppingBasketFull.vue?vue&type=script&lang=js&"
export * from "./ShoppingBasketFull.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingBasketFull.vue?vue&type=style&index=0&id=07945b3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07945b3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07945b3d')) {
      api.createRecord('07945b3d', component.options)
    } else {
      api.reload('07945b3d', component.options)
    }
    module.hot.accept("./ShoppingBasketFull.vue?vue&type=template&id=07945b3d&scoped=true&", function () {
      api.rerender('07945b3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/ShoppingBasketFull.vue"
export default component.exports